module.exports = __webpack_public_path__ + "static/media/columbia_getty_mobile.2374ac92.jpg";